
import Vue from 'vue';
import { BlockCollection } from '@headlines/exports';

interface Props {
  candidates: Record<string, any>[];
  blockTitle: string;
  showDesc: boolean;
  gridClass: string;
}

interface PageWindow extends Window {
  Fancybox: any;
}

declare const window: PageWindow;

export default Vue.extend<unknown, unknown, unknown, Props>({
  components: {
    BlockType8: BlockCollection.BlockType8,
  },
  props: {
    candidates: {
      type: Array,
      required: true,
    },
    blockTitle: {
      type: String,
      default: '',
    },
    showDesc: {
      type: Boolean,
      default: false,
    },
    gridClass: {
      type: String,
    },
  },

  async mounted() {
    const script = document.createElement('script');
    script.src = 'https://code.jquery.com/jquery-3.6.0.min.js'; // Include jQuery as a dependency
    script.async = true;
    script.onload = () => {
      const fancyboxScript = document.createElement('script');
      fancyboxScript.src = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.umd.js';
      fancyboxScript.async = true;
      fancyboxScript.onload = () => {
        // Initialize Fancybox
        // eslint-disable-next-line no-undef
        window.Fancybox.bind('[data-fancybox]', {
          type: 'inline',
          closeButton: 'auto',
          smallBtn: true,
          iframe: {
            preload: false,
          },

          preload: false,
        });
      };
      document.head.appendChild(fancyboxScript);
    };
    document.head.appendChild(script);

    // Load Fancybox CSS from CDN
    const cssLink = document.createElement('link');
    cssLink.rel = 'stylesheet';
    cssLink.href = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.css';
    document.head.appendChild(cssLink);
  },
});
